/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/awardFinder/resources/js/aaValidatorPlugin.js
*    TO   --> ./webapps/homepage-web/src/main/assets/js/home/aa-validator-plugin.js
**/

;(function($) {

	var $this = undefined;
	var options = undefined;

	/**
	 * This function initializes the validator with
	 * parameters. These parameters override the defaults
	 * found in $.fn.scValidator.defaults object in this file.
	 *
	 * Names of fields to be validated are passed into the object. Example:
	 *
	 * $('#myForm').aaValidator({
	 *		trim: true,
	 *		fields: {
	 *			'firstName': {
	 *				required: true,
	 *				minLength: 2,
	 *				maxLength: 15,
	 *				matches: "a-zA-Z-' "
	 *				custom_hasB: function(fieldVal) { return fieldVal.indexOf('B') == -1; }
	 *			},
     *           'lastName': {
	 *				required: true,
	 *				minLength: 2,
     *              maxLength: 20,
	 *				matches: "a-zA-Z-' "
	 *			}
	 *		}
	 *	});
	 *
	 */
	$.fn.aaValidator = function( params ) {
		options = $.extend({}, $.fn.aaValidator.defaults, params);

		$this = $(this);

        registerMaxlengthRule();

        options.validateEventObj.on(options.validateOnEvent, function() {
			resetErrorCount();
			validate();
			if(options.numErrors > 0) {
				if(typeof options.onFailure === 'function') {
					options.onFailure();
				}
				return false;
			}
			if(typeof options.onSuccess === 'function') {
				return options.onSuccess();
			}
		});
	};

	// PRIVATE functions

	var validate = function() {

		removeAllErrors();

		// iterate through each field for which validations defined
		$.each(options.fields, function(fieldName, rules) {
			var $input = $this.find('input[name="'+fieldName+'"]');
			var errorFieldName = rules.errorFieldName;
			var inputVal = $input.val();
			if(options.trim && inputVal != '') {
				inputVal = $.trim(inputVal);
				$input.val(inputVal);
			}

			if (rules.validatePrecondition !== undefined && !rules.validatePrecondition()) {
                // validate precondition not met
                return true;
            }

			// field empty, and not required, skip validation
			// of field
			if(!rules.required && inputVal == '') {
				return true; // same as continue
			}

			// iterate through each rule for the field
			$.each(rules, function(ruleName, value) {

				var ruleVal = value;
				var showMessage = true;
				// check if the rule value is an
				// object with extra parameter
				// eg: maxLength: { rule: 7, showMessage: false }
				if(typeof value === 'object') {
					ruleVal = value.rule;

					if(value.showMessage !== undefined) {
						showMessage = value.showMessage;
					}
				}

				if(ruleName == 'required') {
					showMessage = false;
				}

				/*
				 * if no event specified by the user (value.event not set), only execute the rule onSubmit
				 * if an event specified, check that it matches the event passed
				 * eg rule with    specified event: restrict: { rule: "a-zA-Z", event: "keyup" }
				 * eg rule without specified event: restrict: "a-zA-Z"
				 */
				var result = true;

				// predefined function
				if(validators[ruleName] && typeof ruleVal !== 'function') {
					result = validators[ruleName].apply( $input, [inputVal, ruleVal] );
				}

				// custom function
				else if(ruleName.substring(0,6) == 'custom' && typeof ruleVal === 'function') {
					result = ruleVal.apply( $input, [inputVal]);
				}

				else {
					// NOT a rule. Eg: errorFieldName
				}
				if(!result) {
					if(showMessage) {
					}
					addError($input, showMessage, errorFieldName, ruleName);
					if(ruleName == 'required') {
						return false; // quit processing rules for field
					}
				}

			});


		});
	};

    var registerMaxlengthRule = function (){
        $.each(options.fields, function(fieldName, rules) {
            var ruleVal = rules.maxLength;

            if(ruleVal) {
                var $input = $this.find('input[name="'+fieldName+'"]');
                $input.attr("maxlength" , ruleVal);
            }
        });
    };

	// show message
	// if no prev error, add error
	var addError = function($field, showMessage, errorFieldName, ruleName) {
		if(showMessage) {
			errorDivLocator($field, errorFieldName, ruleName).show();
		}
		addErrorClass($field);
		incrementErrorCount();
	};

	var removeAllErrors = function($field) {
		$.each(options.fields, function(fieldName, rules) {
			var $input = $this.find('input[name="'+fieldName+'"]');
			var errorFieldName = rules.errorFieldName;
			removeErrorIfExists($input, errorFieldName);
		});
	};

	var removeErrorIfExists = function($field, errorFieldName) {
		if(hasError($field)) {
			getErrorContainerForField($field, errorFieldName).find('div').hide();
			removeErrorClass($field);
		}
	};

	var resetErrorCount = function() {
		options.numErrors = 0;
		$('#'+options.generalErrorDiv).hide();
	};

	var addErrorClass = function($field) {
		$field.addClass(options.errorClass);
		getErrorLabelForField($field).addClass(options.labelErrorClass);
	};

	var removeErrorClass = function($field) {
		$field.removeClass(options.errorClass);
		getErrorLabelForField($field).removeClass(options.labelErrorClass);
	};

	var hasError = function($field) {
		return $field.hasClass(options.errorClass);
	};

	var incrementErrorCount = function() {
		options.numErrors++;
		if(options.numErrors == 1) {
			$('#'+options.generalErrorDiv).show();
		}
	};

	var decrementErrorCount = function() {
		if(options.numErrors) {
			options.numErrors--;
			if(options.numErrors==0) {
				$('#'+options.generalErrorDiv).hide();
			}
		}
	};

	var errorDivLocator = function($field, errorFieldName, ruleName) {
		var errorContainer = getErrorContainerForField($field, errorFieldName);
		var $generalSpan = errorContainer.find('.general');
		var $ruleSpan = errorContainer.find('.' + ruleName);

		if($ruleSpan.length != 0) return $ruleSpan;
		else if($generalSpan.length != 0) return $generalSpan;
		else return errorContainer;

	};

	var getErrorContainerForField = function($field, errorFieldName) {
		if(!errorFieldName) {
			errorFieldName = $field.attr('name');
		}
		return $('.'+options.errorDiv+'[data-field="'+errorFieldName+'"]');
	};

	var getErrorLabelForField = function($field) {
		return $('label[for="' + $field.attr("id") + '"]');
	}

	var validators = {

		minLength: function(str, n) {

			return (str.length >= n);
		},

		maxLength: function(str, n) {
            this.attr("maxlength" , n);
			return (str.length <= n);
		},

		len: function(str, n) {
			return (str.length == n);
		},

		required: function(str, val) {
			if(val) {
				return (str.length > 0);
			}
			return true;
		},

		numeric: function(str, val) {
			if(val) {
				return !isNaN(str);
			}
		},

		matches: function(str, rule) {
			var pattern=new RegExp("^[" + rule + ']*$','g');
			return str.match(pattern);
		}
	};

	$.fn.aaValidator.defaults = {
		errorClass: 'input-error',
		labelErrorClass: 'is-error',
		generalErrorDiv: 'frontEndGenericError',
		errorDiv: 'errorMessage',
		validateOnEvent: 'submit',
		validateEventObj: $(this)
	};

})(jQuery);
